import CompanyRoutes from "../../apiRoutes/CompanyRoutes";
import publicRoutes from "../../apiRoutes/publicRoutes";
import { api } from "../ConsumeApiController";

/**
 * Consulta un vehículo por su placa para el autocompletado.
 */
export async function searchVehicle(plate) {
    // Limpiamos la placa de espacios y guiones antes de enviarla
    const cleanPlate = plate.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    const response = await api.get(`${CompanyRoutes.HELP.VEHICLES.SEARCH}/${cleanPlate}`);
    return response;
}

/**
 * Registra un nuevo despacho de salida.
 */
export async function createDispatch(payload) {
    // 1. Limpieza de datos
    const cleanPayload = {
        ...payload,
        // Nos aseguramos de enviar la placa limpia
        plate: payload.plate.replace(/[^A-Za-z0-9]/g, '').toUpperCase(),
        // Limpiamos espacios en blanco al inicio o final de los textos
        driver_name: payload.driver_name.trim(),
        driver_ci: payload.driver_ci.trim().toUpperCase(), 
        driver_phone: payload.driver_phone.trim(),
    };

    // 2. Enviamos el payload al backend
    const response = await api.post(CompanyRoutes.HELP.DISPATCHES.BASE, cleanPayload);
    
    return response;
}

/**
 * Obtiene la lista interna de despachos para la Mesa de Control.
 * Soporta filtrado dinámico.
 */
export async function getDispatches(filters = {}) {
    const cleanFilters = { ...filters };

    // Limpiamos los filtros antes de enviarlos
    if (cleanFilters.status === "all" || !cleanFilters.status) delete cleanFilters.status;
    if (!cleanFilters.search || cleanFilters.search === "") delete cleanFilters.search;

    // Convertimos el objeto a una cadena de consulta (query string)
    const queryString = new URLSearchParams(cleanFilters).toString();
    
    // Construimos la URL final
    const finalUrl = queryString 
        ? `${CompanyRoutes.HELP.DISPATCHES.BASE}?${queryString}` 
        : CompanyRoutes.HELP.DISPATCHES.BASE;

    console.log("URL final enviada a Laravel (Despachos):", finalUrl);
    const response = await api.get(finalUrl);
    
    return response;
}

/**
 * Obtiene la lista pública (anonimizada) para el Portal de Transparencia.
 */
export async function getPublicDispatches() {
    const response = await api.get(publicRoutes.HELP.DISPATCHES.TRANSPARENCY);
    return response;
}

/**
 * Actualiza el estatus de un despacho y registra la bitácora.
 */
export async function updateDispatchStatus(id, payload) {
    // Nota: Si en Laravel definiste la ruta como PUT, usamos api.put. 
    // Si usaste Route::post en api.php, cambia esto a api.post.
    const response = await api.put(`${CompanyRoutes.HELP.DISPATCHES.BASE}/${id}/status`, payload);
    return response;
}